export enum AvgRoutesEnum {
    Rights = 'rechten',
    Thanks = 'bedankt',
    Identification = 'identificatie',
}
